import type { RefObject } from 'react';
import type {
  ParallaxConfig,
  RevealRectangleConfig,
  ScaleUpConfig,
  TransitionConfig,
  TransitionType,
} from './ScrollTransition.data';
import { revealRectangle } from '../../../util/animation/reveal/reveal';

interface ScrollTransitionRefs {
  elementRef: RefObject<HTMLElement | null>;
  type: TransitionType;
  config?: TransitionConfig;
  disableTriggerInOnScroll?: boolean;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, type, config = {}, disableTriggerInOnScroll }: ScrollTransitionRefs,
): void {
  if (elementRef.current && !disableTriggerInOnScroll) {
    if (type === 'parallax') {
      const { direction, offset = 50, speed = 1, ease = 'none' } = config as ParallaxConfig;
      const measure = direction === 'horizontal' ? 'offsetWidth' : 'offsetHeight';
      const size = elementRef.current[measure];

      const distance = (offset / size) * 100;
      const offsetPercent = direction === 'horizontal' ? 'xPercent' : 'yPercent';

      timeline.fromTo(
        elementRef.current,
        {
          // willChange: 'transform',
          [offsetPercent]: distance * speed,
        },
        {
          // willChange: 'transform',
          [offsetPercent]: -distance * speed,
          duration: 1,
          ease,
        },
      );
    }

    if (type === 'revealRectangle') {
      const { from = 'center' } = config as RevealRectangleConfig;
      timeline.add(revealRectangle(elementRef.current, { from }));
    }

    if (type === 'scaleUp') {
      const { scale = 1.2 } = config as ScaleUpConfig;
      const offset = ((scale - 1) / 2) * 100;
      timeline.fromTo(
        elementRef.current,
        {
          // willChange: 'transform',
          yPercent: -offset,
          scale: 1,
        },
        {
          scale,
          // willChange: 'transform',
          yPercent: offset,
          duration: 1,
          ease: 'none',
        },
      );
    }
  }
}
